import React from 'react';
import { useLocation } from 'react-router';

// Import utils
import { scrollToId } from '../../utils/scroll';

/**
 * Hook that returns a handler function for hash link clicks.
 * Handles the case where we're already on the landing page with the same hash,
 * preventing navigation and manually scrolling to ensure clicking again works.
 *
 * @returns A function that handles hash link clicks
 */
export default function useHashLinkClick() {
  const location = useLocation();

  const onHashLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    id: string,
  ) => {
    // If we are already on the landing page AND the hash is the same,
    // React Router won't change location and our effect won't rerun.
    // Prevent navigation and scroll manually in that case so clicking again works.
    if (location.pathname === '/' && location.hash === `#${id}`) {
      e.preventDefault();
      scrollToId(id);
    }
  };

  return onHashLinkClick;
}
